module.exports = __webpack_public_path__ + "img/lpt.9b0c52db.svg";